// src/constants/newLoginConfig.js

export const NEW_LOGIN_CONFIG = {
  AUTH_URL: process.env.REACT_APP_NEW_LOGIN_AUTH_URL,
  STATE: process.env.REACT_APP_NEW_LOGIN_STATE,
  REDIRECT_URL: process.env.REACT_APP_NEW_LOGIN_REDIRECT_URL,
  IAM_RESPONSE_TYPE: process.env.REACT_APP_NEW_LOGIN_IAM_RESPONSE_TYPE,
};

export const LOGIN_TYPE = {
  IAM: 'iam',
  IDENTITY: 'identity',
};

// SSO Types
export const SSO_TYPE = {
  OPENAM: 'openam', // For PwC Users
  IAM: 'iam', // For Client Users
};
